import { WarningOutlined } from "@ant-design/icons";
import { Modal, Typography } from "antd";
import React, { useMemo } from "react";

import type { FC, JSX } from "react";

interface Props {
  confirmTitleText: string;
  additionalInfo?: JSX.Element;
  okText?: string;
  cancelText?: string;
  visible: boolean;
  onClose: () => void;
  onOk: () => void;
  warning?: boolean;
  confirmLoading?: boolean;
}

const displayFlex = { display: "flex" };
const flex1 = { flex: 1 };
const flex9 = { flex: 9 };
const margin8px = { margin: "0 0 8px" };

const ConfirmModal: FC<Props> = ({
  confirmTitleText,
  additionalInfo,
  okText,
  cancelText,
  visible,
  onClose,
  onOk,
  warning,
  confirmLoading,
}) => {
  const dangerStyle = useMemo(() => ({ danger: warning }), [warning]);
  return (
    <Modal
      visible={visible}
      okText={okText ?? undefined}
      okButtonProps={dangerStyle}
      cancelText={cancelText ?? undefined}
      onCancel={onClose}
      onOk={onOk}
      closable={false}
      destroyOnClose
      centered
      confirmLoading={confirmLoading ?? undefined}
      transitionName=""
    >
      <div style={displayFlex}>
        {warning && (
          <Typography.Title level={4} style={flex1}>
            <Typography.Text type="warning">
              <WarningOutlined />
            </Typography.Text>
          </Typography.Title>
        )}
        <Typography.Text style={flex9}>
          <Typography.Title level={5} style={margin8px}>
            {confirmTitleText}
          </Typography.Title>
          {additionalInfo}
        </Typography.Text>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
